import type { ComponentProps } from 'react';

import type { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';

import {
  SmallTileButtonOrLink,
  SmallTileHoverEffect,
} from './SmallTile.styled';

type Props = ComponentProps<typeof ButtonOrLink> & {
  withHoverEffect?: boolean;
};

export function SmallTile({ withHoverEffect, children, ...props }: Props) {
  return (
    <SmallTileButtonOrLink
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {withHoverEffect && <SmallTileHoverEffect />}
      {children}
    </SmallTileButtonOrLink>
  );
}
